import { orderFilters } from '../../views/viola/basicConfig'

const ordersReducer = (state = { filters: orderFilters }, { type, payload }) => {
  switch (type) {
    case 'UPDATE_ORDERS':
      let newState = { ...state }
      newState.filters = { ...newState.filters, ...payload }
      return newState
    default:
      return state
  }
}

export default ordersReducer;